import http from '../http'

const api = {
    // 获取导航
    getProduct(params) {
        return http.get('/wp-json/dt_api/product', {
            params,
        })
    }
}

const state = {
    basicInfo: null,
    detailInfo: {
        content: [],
    },
    products: [],
    currentProductSlug: ''
}

const mutations = {
    GET_PRODUCT: state => {
        return state
    },
    SET_CURRENT_PRODUCT_SLUG: (state, slug) => {
        state.currentProductSlug = slug
    },
    SET_PRODUCT: (state, {basicInfo}) => {
        state.basicInfo = basicInfo
    },
    SET_DETAIL_INFO: (state, {detailInfo}) => {
        state.detailInfo = detailInfo
    },
    SET_PRODUCTS: (state, {products}) => {
        state.products = products
    },
}

// 所有的mutations转换成actions进行调用
const actions = {
    async getProduct({commit}, slug) {
        commit('GET_PRODUCT')
        const lang = window.localStorage.getItem('lang')

        await api.getProduct({
            slug: slug,
            lang,
        }).then(res => {
            if (res.data.data) {
                commit('SET_PRODUCT', {
                    basicInfo: res.data.data,
                })

                commit('SET_CURRENT_PRODUCT_SLUG', slug)

                commit('SET_DETAIL_INFO', {
                    detailInfo: res.data.data
                })

                commit('SET_PRODUCTS', {
                    products: res.data.data.recommended_products,
                })

                commit('common/SET_PAGE_THEME',  {
                    theme: res.data.data.theme
                }, {root: true})
                commit('common/SET_THEME',  {
                    theme: res.data.data.theme,
                    wxShare: res.data.data.wechat_share,
                }, {root: true})
            }
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
